export enum NegotiationMode {
  Company,
  Installer,
}
